module.exports = __webpack_public_path__ + "static/media/m_beard_long_round__oval.1939de43.png";